import script from "./ProductionChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionChart.vue?vue&type=script&setup=true&lang=js"

import "./ProductionChart.vue?vue&type=style&index=0&id=38a73cd3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a73cd3"]])

export default __exports__